import { createSelector } from 'reselect';
import { PRACTICE, QUESTIONS } from '../../constants/assessmentItemType';

export const getVocabTQVMContent = (state, pageType, questionIndex = 0) => {
    let content;

    switch (pageType) {
        case PRACTICE:
            content = state.practice;
            break;
        case QUESTIONS:
            content = state.questions;
            break;
        default:
            content = [{}];
    }

    return content[questionIndex] || {};
};

export const getIsVocabTQVMDataFetched = state => state.isDataFetched;

export const getVocabTQVMStimulusInfo = createSelector(
    [getVocabTQVMContent],
    content => content.stimulus || {},
);

export const getVocabTQVMPossibleResponses = createSelector(
    [getVocabTQVMContent],
    content => content.possibleResponses || [],
);

export const getVocabTQVMTotalQuestions = state => state.questions.length;

export const getVocabTQVMFormId = state => state.formId;

export const getVocabTQVMSelectedResponseId = (state, pageType, questionIndex, responseIdx) => {
    const possibleResponses = getVocabTQVMPossibleResponses(state, pageType, questionIndex);

    if (possibleResponses && possibleResponses[responseIdx]) {
        return possibleResponses[responseIdx].id;
    }

    return null;
};
